/* ============================================================
   coloris-gamme.js  v2
   v2 : reprise de tous les marquages du module v16 (window.mpPerso.exportState / importState).
   1. Survol / focus d'une pastille : le libellé affiche le nom du coloris.
   2. Préchargement de la fiche au survol (navigation plus rapide).
   3. Changement de coloris : la personnalisation en cours (module
      personnalisation-produit) est mémorisée puis réappliquée sur la
      nouvelle fiche. sessionStorage : propre à l'onglet, expire après 30 min.
   ============================================================ */

(function () {
  'use strict';

  var KEY = 'mp-coloris-perso';
  var MAX_AGE_MS = 30 * 60 * 1000;
  var LOG = '[mp-coloris]';

  var root = document.querySelector('[data-mp-coloris]');
  if (!root) return;

  /* ── 1. Libellé au survol ────────── */
  var current = root.querySelector('[data-mp-coloris-current]');
  var currentText = current ? current.textContent : '';
  root.querySelectorAll('.mp-coloris__swatch').forEach(function (sw) {
    var name = sw.getAttribute('data-name');
    if (!name || !current) return;
    var show = function () { current.textContent = name; };
    var reset = function () { current.textContent = currentText; };
    sw.addEventListener('mouseenter', show);
    sw.addEventListener('mouseleave', reset);
    sw.addEventListener('focus', show);
    sw.addEventListener('blur', reset);
  });

  /* ── 2 & 3. Liens vers les autres coloris ────────── */
  var prefetched = {};
  function prefetch(href) {
    if (prefetched[href]) return;
    prefetched[href] = true;
    var l = document.createElement('link');
    l.rel = 'prefetch'; l.href = href;
    document.head.appendChild(l);
  }
  root.querySelectorAll('a[data-mp-coloris-link]').forEach(function (a) {
    a.addEventListener('mouseenter', function () { prefetch(a.href); }, { passive: true });
    a.addEventListener('touchstart', function () { prefetch(a.href); }, { passive: true });
    a.addEventListener('click', savePerso);
  });

  /* ── Mémoriser la personnalisation ────────── */
  function savePerso() {
    var mod = document.getElementById('mp-perso-module');
    if (!mod) return;
    var cb = document.getElementById('mp-perso-checkbox');
    var active = !!(cb && cb.checked);
    var noLogo = !!mod.querySelector('input[name="mp-logo"][value="sans"]:checked');
    try {
      if (!active && !noLogo) { sessionStorage.removeItem(KEY); return; }
      // Module v16 : tous les marquages sont exportés tels quels (les champs ne montrent que le marquage en cours)
      var perso = (window.mpPerso && window.mpPerso.exportState) ? window.mpPerso.exportState() : null;
      var fields = [];
      mod.querySelectorAll('input, textarea').forEach(function (el) {
        if (el.type === 'radio') {
          if (el.checked && el.name) fields.push({ t: 'radio', name: el.name, v: el.value });
        } else if (el.type === 'checkbox') {
          if (el.id) fields.push({ t: 'checkbox', id: el.id, v: el.checked });
        } else if ((el.type === 'text' || el.tagName === 'TEXTAREA') && el.id) {
          fields.push({ t: 'text', id: el.id, v: el.value });
        }
      });
      sessionStorage.setItem(KEY, JSON.stringify({ ts: Date.now(), from: location.pathname, fields: fields, perso: perso }));
    } catch (e) { /* stockage indisponible : on navigue sans mémoriser */ }
  }

  /* ── Réappliquer à l'arrivée ────────── */
  function readSaved() {
    var raw = null;
    try { raw = sessionStorage.getItem(KEY); sessionStorage.removeItem(KEY); } catch (e) { return null; }
    if (!raw) return null;
    try {
      var data = JSON.parse(raw);
      if (!data || !data.fields || Date.now() - data.ts > MAX_AGE_MS) return null;
      if (data.from === location.pathname) return null;   // simple rechargement : rien à faire
      return data;
    } catch (e) { return null; }
  }

  function cssEsc(s) {
    return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/["\\]/g, '\\$&');
  }

  function applyField(mod, f) {
    var el;
    if (f.t === 'checkbox') {
      el = document.getElementById(f.id);
      if (!el || !mod.contains(el) || el.checked === f.v) return;
      el.checked = f.v;
      el.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (f.t === 'radio') {
      el = mod.querySelector('input[type="radio"][name="' + cssEsc(f.name) + '"][value="' + cssEsc(f.v) + '"]');
      if (!el || el.checked || el.disabled) return;
      var label = el.closest('label');
      if (label && label.style.display === 'none') return;   // motif non proposé sur ce produit
      el.checked = true;
      el.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (f.t === 'text') {
      el = document.getElementById(f.id);
      if (!el || !mod.contains(el) || el.value === f.v) return;
      el.value = f.v;
      el.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  function restorePerso(data) {
    var mod = document.getElementById('mp-perso-module');
    if (!mod) return;
    // Le module fait défiler la page quand il s'ouvre ou change de face : on garde le visiteur
    // en haut de la fiche, sur la photo du nouveau coloris.
    var origSIV = Element.prototype.scrollIntoView, origScrollTo = window.scrollTo;
    Element.prototype.scrollIntoView = function () {};
    window.scrollTo = function () {};
    try {
      if (data.perso && window.mpPerso && window.mpPerso.importState && window.mpPerso.importState(data.perso)) {
        console.info(LOG, 'personnalisation reprise depuis', data.from, '(' + data.perso.markings.length + ' marquage(s))');
        return;
      }
      data.fields.forEach(function (f) { if (f.t === 'checkbox') applyField(mod, f); });
      // Plusieurs passes : faces, positions et orientations sont recréées selon les choix précédents
      for (var pass = 0; pass < 3; pass++) {
        data.fields.forEach(function (f) { if (f.t !== 'checkbox') applyField(mod, f); });
      }
      console.info(LOG, 'personnalisation reprise depuis', data.from);
    } catch (e) {
      console.warn(LOG, 'reprise impossible', e);
    } finally {
      setTimeout(function () {
        Element.prototype.scrollIntoView = origSIV;
        window.scrollTo = origScrollTo;
      }, 700);
    }
  }

  function whenPersoReady(cb) {
    var tries = 0;
    (function check() {
      // init() du module pose cette classe puis s'exécute d'un bloc : au tour suivant, il est prêt
      if (document.body.classList.contains('mp-perso-page')) return setTimeout(cb, 0);
      if (++tries > 60) return;      // ~3 s : module absent ou non initialisé
      setTimeout(check, 50);
    })();
  }

  var saved = readSaved();
  if (saved) {
    var go = function () { setTimeout(function () { whenPersoReady(function () { restorePerso(saved); }); }, 0); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go);
    else go();
  }
})();
